export default {
	'pln_iot_individual': {
		id: 'pln_iot_individual',
		name: 'Professional',
		description: 'For your business IoT projects / prototyping'
	},
	'pln_iot_student': {
		id: 'pln_iot_individual',
		name: 'Student',
		description: 'For students with a .edu email address'
	},
	'pln_iot_enterprise': {
		id: 'pln_iot_enterprise',
		name: 'Enterprise',
		description: 'For business IoT applications'
	},
	'pln_scope_app_base': {
		id: 'pln_scope_app_base',
		name: 'Base',
		description: null
	},
	'pln_scope_app_starter': {
		id: 'pln_scope_app_starter',
		name: 'Starter',
		description: null
	},
	'pln_scope_app_serialdecode': {
		id: 'pln_scope_app_base',
		name: 'Professional Serial Decode',
		description: null
	},
	'pln_scope_app_power': {
		id: 'pln_scope_app_power',
		name: 'Professional Power',
		description: null
	},
	'pln_scope_app_milgov': {
		id: 'pln_scope_app_milgov',
		name: 'Professional Aerospace & Defense',
		description: null
	},
	'pln_scope_app_automotive': {
		id: 'pln_scope_app_automotive',
		name: 'Professional Automotive',
		description: null
	},
	'pln_scope_app_ultimate': {
		id: 'pln_scope_app_ultimate',
		name: 'Ultimate',
		description: null
	},
	'pln_scope_app_starter': {
		id: 'pln_scope_app_starter',
		name: 'Starter',
		description: null
	},
	'pln_scope_app_serialdecode': {
		id: 'pln_scope_app_base',
		name: 'Professional Serial Decode',
		description: null
	},
	'pln_scope_app_power': {
		id: 'pln_scope_app_power',
		name: 'Professional Power',
		description: null
	},
	'pln_scope_app_milgov': {
		id: 'pln_scope_app_base',
		name: 'Professional Aerospace & Defense',
		description: null
	},
	'pln_scope_app_automotive': {
		id: 'pln_scope_app_automotive',
		name: 'Professional Automotive',
		description: null
	},
	'pln_scope_app_ultimate': {
		id: 'pln_scope_app_ultimate',
		name: 'Ultimate',
		description: null
	},
	'pln_tekdrivefree': {
		id: 'pln_tekdrivefree',
		name: 'Basic',
		description: 'Analysis in the cloud'
	},
	'pln_tekdrivetier1': {
		id: 'pln_tekdrivetier1',
		name: 'Individual',
		description: '200 GB of storage'
	},
	'pln_tekdrivetier2': {
		id: 'pln_tekdrivetier2',
		name: 'Business',
		description: '600 GB of storage',
	},
	'pln_tekdriveenterprise': {
		id: 'pln_tekdriveenterprise',
		name: 'Enterprise',
		description: '2TB+ of storage'
	},
	'pln_tekdrivestarter_v1': {
		id: 'pln_tekdrivestarter',
		name: 'Starter',
		description: '50 GB of storage'
	},
	'pln_tekdrivestarter_promotional_v1': {
		id: 'pln_tekdrivestarter',
		name: 'Starter',
		description: '50 GB of storage'
	},
	'pln_tekdrivepro_v1': {
		id: 'pln_tekdrivepro',
		name: 'Pro',
		description: '600 GB of storage'
	},
	'pln_tekdriveultimate_v1': {
		id: 'pln_tekdriveultimate',
		name: 'Ultimate',
		description: '1TB of storage'
	},
	'pln_scope_app_ultimate_promotional': {
		id: 'pln_scope_app_ultimate',
		name: 'Ultimate',
		description: null
	},
	'pln_scope_app_starter_promotional': {
		id: 'pln_scope_app_starter',
		name: 'Ultimate',
		description: null
	}
};



// WEBPACK FOOTER //
// ./src/store/models/plan-table.js